<div class="panel p-2">
    <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title class="d-block">
                <div class="d-flex flex-row mt-2">
                    <div class="pt-2 me-2">
                        <mat-icon *ngIf="cert.valid" color="" class="panel-icon material-symbols-outlined pt-2" title="valid">verified
                        </mat-icon>
                        <mat-icon *ngIf="!cert.valid" color="" class="panel-icon material-symbols-outlined pt-2" title="invalid">error
                        </mat-icon>
                    </div>
                    <data>
                        <span class="body-title me-3">{{cert.category}}</span> <br>
                        <span class="body-text">{{cert.title}}</span><br>
                    </data>
                    <div class="ms-auto my-3 me-3">
                        <p class="p-2 rounded"
                            [ngClass]="{'badge-bg-danger':!cert.valid, 'badge-bg-success':cert.valid}">{{cert.status}}</p>
                    </div>
                </div>
            </mat-panel-title>
            <!-- <mat-panel-description></mat-panel-description> -->
        </mat-expansion-panel-header>
        <div class="content ps-3">
            <div class="d-flex- flex-row d-none">
                <mat-icon color="accent" class="title-icon me-4 fs-1" *ngIf="cert.renewability == RENEWABILITY.OPEN">cloud_sync</mat-icon>
                <mat-icon color="accent" class="title-icon me-4 fs-1" *ngIf="cert.renewability == RENEWABILITY.CTF">sync</mat-icon>
                <mat-icon color="accent" class="title-icon me-4 fs-1" *ngIf="cert.renewability == RENEWABILITY.OTHER">sync</mat-icon>
                <mat-icon color="accent" class="title-icon me-4 fs-1" *ngIf="cert.renewability == RENEWABILITY.NOT_OPEN">sync_lock</mat-icon>
                <mat-icon color="accent" class="title-icon me-4 fs-1" *ngIf="cert.renewability == RENEWABILITY.NON_RENEWABLE">sync_disabled</mat-icon>
                <div>
                    <div class="item">Valid: <span class="value">
                        {{cert.certDate|date:'mediumDate'}} - {{cert.expires|date:'mediumDate'}}
                    </span> </div>
                    <div *ngIf="cert.status =='Valid'" class="item">Status: <span class="value complete">{{cert.status}}</span> </div>
                    <div *ngIf="cert.status !='Valid'" class="item">Status: <span class="value pending">{{cert.status}}</span></div>
                </div>
            </div>
            
            <p class="mt-2 p-1 badge-bg-success rounded px-2" *ngIf="cert.renewability == RENEWABILITY.OPEN">{{cert.renewabilityDescription}}</p>
            <p class="mt-2 p-1 badge-bg-success rounded px-2" *ngIf="cert.renewability == RENEWABILITY.CTF">{{cert.renewabilityDescription}}</p>
            <p class="mt-2 p-1 badge-bg-success rounded px-2" *ngIf="cert.renewability == RENEWABILITY.OTHER">{{cert.renewabilityDescription}}</p>
            <p class="mt-2 p-1 badge-bg-success rounded px-2" *ngIf="cert.renewability == RENEWABILITY.NOT_OPEN">{{cert.renewabilityDescription}}</p>
            <p class="mt-2 p-1 badge-bg-danger rounded px-2" *ngIf="cert.renewability == RENEWABILITY.NON_RENEWABLE">{{cert.renewabilityDescription}}</p>

            <div>
                <h3 class="mb-0 mt-2 body-title-light"><b>Endorsements:</b></h3>
                <ul class="body-text-light">
                    <li *ngFor="let item of cert.endorsements">{{item.name}}</li>
                </ul>
            </div>
            <div class="my-auto ms-auto body-text-light text-nowrap">
                Start: {{cert.certDate|date:'mediumDate'}} | Expire: {{cert.expires|date:'mediumDate'}}
            </div>
        </div>
        <div class="text-center mt-2">
            <a *ngIf="cert.valid" mat-stroked-button color="accent" (click)="downloadCert()" style="text-decoration: none;">
                <mat-icon>download_2</mat-icon>
                Download Certificate
            </a>
        </div>
    </mat-expansion-panel>
</div>